module.exports = __webpack_public_path__ + "img/logo 2.b634d7b1.svg";